// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --crm-surface: #ffffff;
  --crm-surface-soft: #f8fafc;
  --crm-ink: #243447;
  --crm-muted: #667085;
  --crm-line: rgba(25, 118, 210, 0.14);
  --crm-blue: #1976d2;
  --crm-blue-dark: #24516f;
  --crm-coral: #ef6f53;
  --crm-green: #18a058;
  --crm-shadow: 0 12px 30px rgba(36, 52, 71, 0.12);
  --crm-shadow-hover: 0 18px 38px rgba(36, 52, 71, 0.18);
}

body {
  background:
    linear-gradient(180deg, #f7fbff 0%, #f2f5f8 45%, #eef3f8 100%);
  color: var(--crm-ink);
}

.main-contenttt,
.list-container,
.use-form-container,
.create-form-container,
.custom-form-container,
.admin-portal,
.sectionnn,
.sectionnnnn,
.brand-form,
.business-form,
.receptionist-form,
.forgot-password-container,
.reset-password-container,
.login-container,
.register-container,
.data-table-container {
  background: rgba(255, 255, 255, 0.96) !important;
  border: 1px solid rgba(25, 118, 210, 0.12) !important;
  border-radius: 8px !important;
  box-shadow: var(--crm-shadow) !important;
}

.brand-card,
.business-card,
.receptionist-card,
.team-card,
.team-section,
.associate-card,
.teeam-carrd,
.membeer-card,
.info-box,
.form-section {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)) !important;
  border: 1px solid var(--crm-line) !important;
  border-bottom: 3px solid rgba(239, 111, 83, 0.74) !important;
  border-radius: 8px !important;
  box-shadow: var(--crm-shadow) !important;
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    border-color 180ms ease,
    background-color 180ms ease !important;
}

.brand-card::before,
.business-card::before,
.receptionist-card::before,
.team-card::before,
.team-section::before,
.associate-card::before,
.teeam-carrd::before,
.membeer-card::before,
.info-box::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(180deg, var(--crm-blue), var(--crm-coral));
  opacity: 0.92;
}

.brand-card:hover,
.business-card:hover,
.receptionist-card:hover,
.team-card:hover,
.team-section:hover,
.associate-card:hover,
.teeam-carrd:hover,
.membeer-card:hover,
.info-box:hover {
  transform: translateY(-4px) !important;
  border-color: rgba(239, 111, 83, 0.34) !important;
  box-shadow: var(--crm-shadow-hover) !important;
}

.brand-info h3,
.business-info h3,
.receptionist-info h3,
.team-header h3,
.teeamm-name,
.membeer-card h3 {
  color: var(--crm-blue-dark) !important;
  letter-spacing: 0 !important;
}

.brand-info h3,
.business-info h3,
.receptionist-info h3,
.team-header h3 {
  border-bottom: 1px solid rgba(25, 118, 210, 0.18) !important;
  padding-bottom: 8px;
}

.brand-info p,
.business-info p,
.receptionist-info p,
.membwer-details p,
.team-card p,
.associate-card p {
  color: var(--crm-muted) !important;
  line-height: 1.45;
}

.brand-info strong,
.business-info strong,
.receptionist-info strong,
.membwer-details strong,
.team-card strong,
.associate-card strong {
  color: var(--crm-ink) !important;
}

.info-box.active-companies {
  background:
    linear-gradient(135deg, var(--crm-blue-dark), var(--crm-blue)) !important;
  border-color: rgba(255, 255, 255, 0.18) !important;
  border-bottom-color: var(--crm-coral) !important;
}

.info-box.call-details {
  background:
    linear-gradient(135deg, #eff6ff, #dcecff) !important;
}

.info-box.stats-details {
  background:
    linear-gradient(135deg, #fff7ed, #eef8ff) !important;
}

.teeamm-name {
  background:
    linear-gradient(135deg, var(--crm-blue-dark), var(--crm-blue)) !important;
  color: #ffffff !important;
}

.brand-cards-container,
.business-cards-container,
.receptionist-cards-container,
.teaaamms-grid,
.teams-section {
  scrollbar-color: var(--crm-coral) #dce6ef !important;
}

.brand-cards-container::-webkit-scrollbar-thumb,
.business-cards-container::-webkit-scrollbar-thumb,
.receptionist-cards-container::-webkit-scrollbar-thumb,
.teaaamms-grid::-webkit-scrollbar-thumb,
.teams-section::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, var(--crm-blue), var(--crm-coral)) !important;
}

.brand-actions button,
.business-actions button,
.receptionist-actions button,
.forrm-actions button,
.submit-buttonn,
.add-brand-btn,
.add-business-btn,
.add-receptionist-btn,
.add-team-button,
.create-button {
  border-radius: 6px !important;
  box-shadow: 0 6px 14px rgba(36, 52, 71, 0.12);
  transition:
    transform 160ms ease,
    box-shadow 160ms ease,
    filter 160ms ease !important;
}

.brand-actions button:hover,
.business-actions button:hover,
.receptionist-actions button:hover,
.forrm-actions button:hover,
.submit-buttonn:hover,
.add-brand-btn:hover,
.add-business-btn:hover,
.add-receptionist-btn:hover,
.add-team-button:hover,
.create-button:hover {
  filter: brightness(1.04);
  transform: translateY(-1px) !important;
  box-shadow: 0 9px 20px rgba(36, 52, 71, 0.18);
}

.form-groupppp input,
.form-groupppp textarea,
.form-groupppp select,
.labell-input input,
.labell-input select,
.use-form-container input,
.use-form-container textarea,
.use-form-container select {
  border-color: rgba(36, 52, 71, 0.18) !important;
  border-radius: 6px !important;
  background: #ffffff !important;
}

.form-groupppp input:focus,
.form-groupppp textarea:focus,
.form-groupppp select:focus,
.labell-input input:focus,
.labell-input select:focus,
.use-form-container input:focus,
.use-form-container textarea:focus,
.use-form-container select:focus {
  border-color: var(--crm-blue) !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14) !important;
}

@media (max-width: 768px) {
  .brand-card,
  .business-card,
  .receptionist-card,
  .team-card,
  .teeam-carrd {
    width: min(92vw, 350px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme-cards.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,gDAAgD;EAChD,sDAAsD;AACxD;;AAEA;EACE;kEACgE;EAChE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;EAgBE,gDAAgD;EAChD,qDAAqD;EACrD,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;;;;;;;;;;EAUE,kBAAkB;EAClB,gBAAgB;EAChB;4FAC0F;EAC1F,4CAA4C;EAC5C,4DAA4D;EAC5D,6BAA6B;EAC7B,wCAAwC;EACxC;;;;0CAIwC;AAC1C;;AAEA;;;;;;;;;EASE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,sEAAsE;EACtE,aAAa;AACf;;AAEA;;;;;;;;;EASE,sCAAsC;EACtC,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;;;;;;EAME,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;;;EAIE,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;;;;;;EAME,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;;;;;;EAME,gCAAgC;AAClC;;AAEA;EACE;6EAC2E;EAC3E,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;EACE;wDACsD;AACxD;;AAEA;EACE;wDACsD;AACxD;;AAEA;EACE;6EAC2E;EAC3E,yBAAyB;AAC3B;;AAEA;;;;;EAKE,oDAAoD;AACtD;;AAEA;;;;;EAKE,gFAAgF;AAClF;;AAEA;;;;;;;;;;EAUE,6BAA6B;EAC7B,6CAA6C;EAC7C;;;gCAG8B;AAChC;;AAEA;;;;;;;;;;EAUE,wBAAwB;EACxB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;;;;;;;;EAQE,+CAA+C;EAC/C,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;;;;;;;EAQE,wCAAwC;EACxC,yDAAyD;AAC3D;;AAEA;EACE;;;;;IAKE,kCAAkC;EACpC;AACF","sourcesContent":[":root {\n  --crm-surface: #ffffff;\n  --crm-surface-soft: #f8fafc;\n  --crm-ink: #243447;\n  --crm-muted: #667085;\n  --crm-line: rgba(25, 118, 210, 0.14);\n  --crm-blue: #1976d2;\n  --crm-blue-dark: #24516f;\n  --crm-coral: #ef6f53;\n  --crm-green: #18a058;\n  --crm-shadow: 0 12px 30px rgba(36, 52, 71, 0.12);\n  --crm-shadow-hover: 0 18px 38px rgba(36, 52, 71, 0.18);\n}\n\nbody {\n  background:\n    linear-gradient(180deg, #f7fbff 0%, #f2f5f8 45%, #eef3f8 100%);\n  color: var(--crm-ink);\n}\n\n.main-contenttt,\n.list-container,\n.use-form-container,\n.create-form-container,\n.custom-form-container,\n.admin-portal,\n.sectionnn,\n.sectionnnnn,\n.brand-form,\n.business-form,\n.receptionist-form,\n.forgot-password-container,\n.reset-password-container,\n.login-container,\n.register-container,\n.data-table-container {\n  background: rgba(255, 255, 255, 0.96) !important;\n  border: 1px solid rgba(25, 118, 210, 0.12) !important;\n  border-radius: 8px !important;\n  box-shadow: var(--crm-shadow) !important;\n}\n\n.brand-card,\n.business-card,\n.receptionist-card,\n.team-card,\n.team-section,\n.associate-card,\n.teeam-carrd,\n.membeer-card,\n.info-box,\n.form-section {\n  position: relative;\n  overflow: hidden;\n  background:\n    linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 255, 0.96)) !important;\n  border: 1px solid var(--crm-line) !important;\n  border-bottom: 3px solid rgba(239, 111, 83, 0.74) !important;\n  border-radius: 8px !important;\n  box-shadow: var(--crm-shadow) !important;\n  transition:\n    transform 180ms ease,\n    box-shadow 180ms ease,\n    border-color 180ms ease,\n    background-color 180ms ease !important;\n}\n\n.brand-card::before,\n.business-card::before,\n.receptionist-card::before,\n.team-card::before,\n.team-section::before,\n.associate-card::before,\n.teeam-carrd::before,\n.membeer-card::before,\n.info-box::before {\n  content: '';\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(180deg, var(--crm-blue), var(--crm-coral));\n  opacity: 0.92;\n}\n\n.brand-card:hover,\n.business-card:hover,\n.receptionist-card:hover,\n.team-card:hover,\n.team-section:hover,\n.associate-card:hover,\n.teeam-carrd:hover,\n.membeer-card:hover,\n.info-box:hover {\n  transform: translateY(-4px) !important;\n  border-color: rgba(239, 111, 83, 0.34) !important;\n  box-shadow: var(--crm-shadow-hover) !important;\n}\n\n.brand-info h3,\n.business-info h3,\n.receptionist-info h3,\n.team-header h3,\n.teeamm-name,\n.membeer-card h3 {\n  color: var(--crm-blue-dark) !important;\n  letter-spacing: 0 !important;\n}\n\n.brand-info h3,\n.business-info h3,\n.receptionist-info h3,\n.team-header h3 {\n  border-bottom: 1px solid rgba(25, 118, 210, 0.18) !important;\n  padding-bottom: 8px;\n}\n\n.brand-info p,\n.business-info p,\n.receptionist-info p,\n.membwer-details p,\n.team-card p,\n.associate-card p {\n  color: var(--crm-muted) !important;\n  line-height: 1.45;\n}\n\n.brand-info strong,\n.business-info strong,\n.receptionist-info strong,\n.membwer-details strong,\n.team-card strong,\n.associate-card strong {\n  color: var(--crm-ink) !important;\n}\n\n.info-box.active-companies {\n  background:\n    linear-gradient(135deg, var(--crm-blue-dark), var(--crm-blue)) !important;\n  border-color: rgba(255, 255, 255, 0.18) !important;\n  border-bottom-color: var(--crm-coral) !important;\n}\n\n.info-box.call-details {\n  background:\n    linear-gradient(135deg, #eff6ff, #dcecff) !important;\n}\n\n.info-box.stats-details {\n  background:\n    linear-gradient(135deg, #fff7ed, #eef8ff) !important;\n}\n\n.teeamm-name {\n  background:\n    linear-gradient(135deg, var(--crm-blue-dark), var(--crm-blue)) !important;\n  color: #ffffff !important;\n}\n\n.brand-cards-container,\n.business-cards-container,\n.receptionist-cards-container,\n.teaaamms-grid,\n.teams-section {\n  scrollbar-color: var(--crm-coral) #dce6ef !important;\n}\n\n.brand-cards-container::-webkit-scrollbar-thumb,\n.business-cards-container::-webkit-scrollbar-thumb,\n.receptionist-cards-container::-webkit-scrollbar-thumb,\n.teaaamms-grid::-webkit-scrollbar-thumb,\n.teams-section::-webkit-scrollbar-thumb {\n  background: linear-gradient(90deg, var(--crm-blue), var(--crm-coral)) !important;\n}\n\n.brand-actions button,\n.business-actions button,\n.receptionist-actions button,\n.forrm-actions button,\n.submit-buttonn,\n.add-brand-btn,\n.add-business-btn,\n.add-receptionist-btn,\n.add-team-button,\n.create-button {\n  border-radius: 6px !important;\n  box-shadow: 0 6px 14px rgba(36, 52, 71, 0.12);\n  transition:\n    transform 160ms ease,\n    box-shadow 160ms ease,\n    filter 160ms ease !important;\n}\n\n.brand-actions button:hover,\n.business-actions button:hover,\n.receptionist-actions button:hover,\n.forrm-actions button:hover,\n.submit-buttonn:hover,\n.add-brand-btn:hover,\n.add-business-btn:hover,\n.add-receptionist-btn:hover,\n.add-team-button:hover,\n.create-button:hover {\n  filter: brightness(1.04);\n  transform: translateY(-1px) !important;\n  box-shadow: 0 9px 20px rgba(36, 52, 71, 0.18);\n}\n\n.form-groupppp input,\n.form-groupppp textarea,\n.form-groupppp select,\n.labell-input input,\n.labell-input select,\n.use-form-container input,\n.use-form-container textarea,\n.use-form-container select {\n  border-color: rgba(36, 52, 71, 0.18) !important;\n  border-radius: 6px !important;\n  background: #ffffff !important;\n}\n\n.form-groupppp input:focus,\n.form-groupppp textarea:focus,\n.form-groupppp select:focus,\n.labell-input input:focus,\n.labell-input select:focus,\n.use-form-container input:focus,\n.use-form-container textarea:focus,\n.use-form-container select:focus {\n  border-color: var(--crm-blue) !important;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.14) !important;\n}\n\n@media (max-width: 768px) {\n  .brand-card,\n  .business-card,\n  .receptionist-card,\n  .team-card,\n  .teeam-carrd {\n    width: min(92vw, 350px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
